
import { Component, Vue, Watch, Prop } from 'vue-property-decorator';
import { store } from '@/store';
import dayjs from 'dayjs';

@Component
export default class ProgressBar extends Vue {

    @Prop({default: 0}) value!: number;

    internalValue: number = 0;


    @Watch('value', { immediate: true })
    onValuePropChange(): void {
        this.internalValue = this.value;
    }

    public getProgressBarColor(progress: number):string {
        if(progress == 0){
            return "red lighten-1";
        } else if(progress > 0 && progress < 25){
            return "amber lighten-1";
        } else if(progress >= 25 && progress < 75){
            return "yellow lighten-1";
        } else if(progress >= 75 && progress < 100){
            return "lime lighten-1";
        } else{
            return "green lighten-1";
        }
    }
}

